
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden" style={{ backgroundColor: '#0D1B2A' }}>
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/9f954acc409584e03fddf088c02bca27.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-5xl md:text-7xl font-bold mb-6 text-white drop-shadow-lg" style={{ fontFamily: "'Tajawal', sans-serif" }}>
          اكتشف منتجات فريدة
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto text-gray-100 drop-shadow-md" style={{ fontFamily: "'Tajawal', sans-serif" }}>
          تسوق من مجموعة واسعة من المنتجات المتنوعة بأفضل الأسعار وأعلى جودة
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link 
            to="/products" 
            className="px-8 py-4 text-black text-lg font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            style={{ backgroundColor: '#D4A84B' }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#E5B95C'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#D4A84B'}
          >
            تصفح المنتجات
          </Link>
          <Link 
            to="/categories" 
            className="px-8 py-4 text-lg font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer border-2"
            style={{ color: '#D4A84B', borderColor: '#D4A84B', backgroundColor: 'transparent' }}
            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#D4A84B'; e.currentTarget.style.color = '#0D1B2A'; }}
            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#D4A84B'; }}
          >
            استكشف الفئات
          </Link>
        </div>
      </div>
    </section>
  );
}
